const initialState = {
  app: null,
};

export default function signin(state: any = initialState, action: any) {

  switch (action.type) {
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/App.tsx